import moment from 'moment'

export const Regex = {
  username: /^[a-z0-9\-_@.]+$/i,
  email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d^a-zA-Z0-9].{16,}$/,
  firstname: /^[A-Za-z0-9]/,
  lastname: /^[A-Za-z0-9]/
}

export const config = {
  surveyTaskTypeId: 6
}

// Validation rules to be used in forms. If a string is returned, it is the error message
export const Rules = {
  required: (field) => v => !!v || `${field} is required`,
  match: (field, match) => field.value === match.value || `${field.label} does not match ${match.label}`,
  notmatch: (field, match) => field.value !== match.value || `${field.label} matches ${match.label}`,
  account: {
    username: [
      v => !!v || 'Username is required',
      v => Regex.username.test(v) || 'Username may contain letters, numbers, -, @, . and _'
    ],
    location: [
      v => !!v || 'Location is required'
    ],
    email: [
      v => !v || Regex.email.test(v) || 'E-mail must be valid'
    ],
    type: [
      v => !!v || 'The account type is required'
    ]
  },
  admin: {
    name: [
      v => !!v || 'Name is required',
      v => Regex.firstname.test(v) || 'Name may only contain letters, numbers'
    ],
    firstname: [
      v => !!v || 'Firstname is required',
      v => Regex.firstname.test(v) || 'Firstname may only contain letters, numbers'
    ],
    lastname: [
      v => !!v || 'Lastname is required',
      v => Regex.lastname.test(v) || 'Lastname may only contain letters, numbers'
    ]
  }
}

export const uniqueId = () => moment().format('x') + ~~(Math.random() * 9999)

export const servers = {
  dv1: {
    name: 'Development',
    a2e_mvp: 'https://a2e-lead.dev.gbil.mckinsey.com',
    a2e: 'https://lead.dev.gbil.mckinsey.com',
    blueprint_content_manager: 'https://bcm.dev.gbil.mckinsey.com',
    hub: 'https://hub.dev.gbil.mckinsey.com',
    platform: 'https://platform.dev.gbil.mckinsey.com',
    scores: 'https://warehouse.dev.gbil.mckinsey.com',
    asset_manager: 'https://asset-manager.dev.gbil.mckinsey.com',
    game: 'https://dv1-game.dev.gbil.mckinsey.com',
    tech_check: 'https://tech-check.dev.gbil.mckinsey.com',
    launcher: 'https://solve.dev.gbil.mckinsey.com/launcher',
    color: 'green',
    cognito: {
      url: 'https://auth.dev.gbil.mckinsey.com/oauth2/authorize',
      clientId: '74m097kmt8sb4nsr2lvgqpkif0'
    },
    mckid: {
      appId: 'b2dc3ec5-3072-409f-b445-c6b38a9c8d5d',
      oidcConfigUrl: 'https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
      authDriver: 'mid',
      redirectUrl: 'https://hub.dev.gbil.mckinsey.com/redirect',
      logoutRedirectUrl: 'http://hub.dev.gbil.mckinsey.com',
      flow: 'auth-code',
      scopes: ['profile', 'email', 'openid', 'mid-default'],
      verifier_key: '_mid-code-verifier'
    },
    auth_cookie: 'dev.gbil.mckinsey.com',
    asset_browse_enabled: true,
    features: {
      ACCOUNTS_CSV_DOWNLOAD_COLUMNS: [
        'username',
        'password',
        'token',
        'links.check',
        'links.game',
        'assessments.0.location',
        'assessments.0.assessment_group',
        'assessments.0.assessment_date',
        'assessments.0.created_by',
        'assessments.0.created_at',
        'assessments.0.updated_by',
        'assessments.0.updated_at',
        'created_by',
        'created_at',
        'updated_by',
        'updated_at'
      ],
      ACCOUNTS_CSV_DOWNLOAD_DEFAULT_COLUMNS: [
        'username',
        'token',
        'links.check'
      ],
      HIDDEN_LINKS: {
        'Import': '*'
      }
    }
  },
  st1: {
    name: 'Staging',
    a2e_mvp: 'https://a2e-lead.stg.gbil.mckinsey.com',
    a2e: 'https://lead.stg.gbil.mckinsey.com',
    hub: 'https://hub.stg.gbil.mckinsey.com',
    platform: 'https://platform.stg.gbil.mckinsey.com',
    scores: 'https://warehouse.stg.gbil.mckinsey.com',
    asset_manager: 'https://asset-manager.stg.gbil.mckinsey.com',
    game: [
      'https://st1-game.stg.gbil.mckinsey.com',
      'https://st2-game.gbil.mckinsey.com',
      'https://st3-game.stg.gbil.mckinsey.com'
    ],
    tech_check: 'https://tech-check.stg.gbil.mckinsey.com',
    launcher: 'https://solve.stg.gbil.mckinsey.com/launcher',
    color: 'text--darken-2 yellow',
    cognito: {
      url: 'https://auth.stg.gbil.mckinsey.com/oauth2/authorize',
      clientId: '4iu6ld0jmffkalg8hto58qi1es'
    },
    mckid: {
      appId: '779ceb25-fa89-434c-a324-0e5ecf09bf34',
      oidcConfigUrl: 'https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
      authDriver: 'mid',
      redirectUrl: 'https://hub.stg.gbil.mckinsey.com/redirect',
      logoutRedirectUrl: 'https://hub.stg.gbil.mckinsey.com',
      flow: 'auth-code',
      scopes: ['profile', 'email', 'openid', 'mid-default'],
      verifier_key: '_mid-code-verifier'
    },
    auth_cookie: 'stg.gbil.mckinsey.com',
    asset_browse_enabled: false,
    features: {
      ACCOUNTS_CSV_DOWNLOAD_COLUMNS: [
        'username',
        'password',
        'token',
        'links.check',
        'links.game',
        'assessments.0.location',
        'assessments.0.assessment_group',
        'assessments.0.assessment_date',
        'assessments.0.created_by',
        'assessments.0.created_at',
        'assessments.0.updated_by',
        'assessments.0.updated_at',
        'created_by',
        'created_at',
        'updated_by',
        'updated_at'
      ],
      ACCOUNTS_CSV_DOWNLOAD_DEFAULT_COLUMNS: [
        'username',
        'token',
        'links.check',
        'links.game'
      ],
      HIDDEN_LINKS: {
        'Blueprint Manager': '*'
      }
    }
  },
  pd: {
    name: 'Production',
    a2e_mvp: 'https://a2e-lead.gbil.mckinsey.com',
    a2e: 'https://lead.gbil.mckinsey.com',
    hub: 'https://hub.gbil.mckinsey.com',
    platform: 'https://platform.gbil.mckinsey.com',
    scores: 'https://warehouse.gbil.mckinsey.com',
    asset_manager: 'https://asset-manager.gbil.mckinsey.com',
    game: 'https://pd1-game.gbil.mckinsey.com',
    tech_check: 'https://tech-check.gbil.mckinsey.com',
    launcher: 'https://solve.gbil.mckinsey.com/launcher',
    color: 'red',
    asset_browse_enabled: false,
    cognito: {
      url: 'https://auth.gbil.mckinsey.com/oauth2/authorize',
      clientId: '1b6biucdgs34g8tpon0c55tgg'
    },
    mckid: {
      appId: 'd2c346c6-6426-400a-9818-398958838e32',
      oidcConfigUrl: 'https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
      authDriver: 'mid',
      redirectUrl: 'https://hub.gbil.mckinsey.com/redirect',
      logoutRedirectUrl: 'https://hub.gbil.mckinsey.com',
      flow: 'auth-code',
      scopes: ['profile', 'email', 'openid', 'mid-default'],
      verifier_key: '_mid-code-verifier'
    },
    auth_cookie: 'gbil.mckinsey.com',
    features: {
      HIDDEN_LINKS: {
        'Blueprint Manager': '*'
      }
    }
  }
}

// Only show 'Localhost' environment if the code is running locally
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  servers['localhost'] = {
    name: 'Localhost',
    a2e_mvp: 'http://localhost:8084',
    a2e: 'http://localhost:8084',
    tech_check: 'http://localhost:8083',
    game: 'http://localhost:8080',
    hub: 'http://localhost:8080',
    platform: 'http://localhost:8081',
    scores: 'http://localhost:8082',
    asset_manager: 'http://localhost:8085',
    blueprint_content_manager: 'http://localhost:8088',
    asset_browse_enabled: true,
    color: 'text--lighten-5 blue-grey',
    cognito: {
      url: 'https://auth.dev.gbil.mckinsey.com/oauth2/authorize',
      clientId: '74m097kmt8sb4nsr2lvgqpkif0'
    },
    mckid: {
      appId: 'b2dc3ec5-3072-409f-b445-c6b38a9c8d5d',
      oidcConfigUrl: 'https://auth.int.mckinsey.id/auth/realms/r/.well-known/openid-configuration',
      authDriver: 'mid',
      redirectUrl: 'http://localhost:8080/redirect',
      logoutRedirectUrl: 'http://localhost:8080',
      flow: 'auth-code',
      scopes: ['profile', 'email', 'openid', 'mid-default'],
      verifier_key: '_mid-code-verifier'
    },
    placholderLocations: ['North America'],
    placeholderScoreGroups: [{ id: 80, name: 'Imbellus', session_size: 1 }]
  }
}
if (process.env.NODE_ENV === 'test') {
  servers['test'] = {
    name: 'Test',
    platform: 'http://platform',
    color: 'text--lighten-5 blue-grey'
  }
}

/**
 * Validate the extnsion of a filename
 *
 * @param {string} filename
 * @param {array} extensions
 * @param {array} consoleError
 *
 * @return {string|void}
 */
export const isInvalidExtension = (filename, extensions, consoleError = true) => {
  if (!extensions.some(end => filename.endsWith(`.${end}`))) {
    const error = new Error(`"${filename}" (support: ${extensions.join(', ')})`)
    error.name = 'Invalid File Extension'
    if (consoleError) {
      console.error(error)
    }
    return error
  }

  return false
}

/**
 * Validate the file type
 *
 * @param {string} filename
 * @param {array} consoleError
 *
 * @return {string|void}
 */
export const isInvalidFile = (file, consoleError = true) => {
  if (!(file instanceof File)) {
    const error = new Error(`"${file.name}"!`)
    error.name = 'Invalid File'
    if (consoleError) {
      console.error(error)
    }
    return error
  }

  return false
}

/**
 * Sort array of objects by key
 *
 * @param {String} key
 */
export const sortArrayByKey = (key) => (a, b) => a[key].toLowerCase() < b[key].toLowerCase() ? -1 : (a[key].toLowerCase() > b[key].toLowerCase() | 0)
